import React from 'react'
import './../Form.css'
import {useForm, useFormContext} from "react-hook-form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import Button from "../Button/Button";

const TextInput = props => {
    const { width, validation, label, labelIcon, editFieldInModal, editFieldAction, ...inputProps } = props;
    const { id, type} = inputProps;
    if(editFieldInModal){
        inputProps.disabled = true;
    }
    const [show, setShow] =  React.useState(false);
    const showModal = () => setShow(true);
    const handleClose = () => {
        setShow(false);
    }
    const formBinding = useFormContext();
    const { setValue, getValues, register, formState: { errors } } = formBinding;
    const modalDefaultValue = {};
    modalDefaultValue[id]= getValues(id);
    const modalFormBinding = useForm({defaultValues: modalDefaultValue });
    const modalFieldErrors = modalFormBinding.formState.errors;
    const updateAction = async(data) => {
        const value = data[id];
        if(editFieldAction){
            editFieldAction(value);
        }
        setValue(id, value);
        handleClose();
    }

    return (
        <>
        {
            type !== 'hidden' &&
            <div className="form-element">
                <label>
                    { labelIcon && <FontAwesomeIcon icon={labelIcon} color="purple" style={{fontSize:'25px', marginRight:'5px'}}/> }
                    {label}
                    { editFieldInModal && <FontAwesomeIcon icon={faPencilAlt} color="purple" style={{fontSize:'20px', float: 'right'}} onClick={showModal}/> }
                </label>
                <input style={width ?{width: `${width}px`}: {width: "100%"}} onChange={setValue} {...inputProps} {...register(id, validation && validation)}/>
                {errors[id] && <p className="input-error">{errors[id].message}</p>}
            </div>
        }
        {
            type === 'hidden' &&
            <input style={width ?{width: `${width}px`}: {width: "100%"}} onChange={setValue} id={id} type="hidden" {...register(id, validation && validation)}/>
        }
        {
            editFieldInModal &&
            <Modal show={show} contentClassName="modal-content-centre" onHide={handleClose} size='md' centered >
                <Modal.Body>
                    <Modal.Title>Update {label}</Modal.Title>
                        <form id="modal-form" onSubmit={modalFormBinding.handleSubmit(updateAction)}>
                            <div className="form-element">
                                <input style={width ?{width: `${width}px`}: {width: "100%"}} onChange={setValue} type={type} {...modalFormBinding.register(id, validation &&validation)}/>
                                {modalFieldErrors[id] && <p className="input-error">{modalFieldErrors[id].message}</p>}
                            </div>
                            <Button label="Update"/>
                        </form>
                </Modal.Body>
            </Modal>
        }
        </>
    )
}
export default TextInput
